'use strict';

namespace Core {

    class ReviewSnippetBrowser {

        // Attr
        hotel: any;

        private elements: any;
        private eventNamespace = 'reviewsnippetbrowser';
        private show: boolean = false;

        private slickOptions: any = {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            rtl: TRPCONFIG.Rtl,
            speed: 200,
            autoplay: true,
            autoplaySpeed: 6000
        };

        constructor (
            private $scope: ng.IScope,
            private $q: ng.IQService,
            private $interval: ng.IIntervalService,
            private $timeout: ng.ITimeoutService,
            private $locale: any
        ) {
        }

        init (elements): void {
            this.elements = elements;
            this.$scope.$watch('rsb.hotel', (val) => {
                if (val) {
                    this.initSlick();
                }
            });
        }

        // private initSlick(): void {
        //     this.elements.carousel.slick(this.slickOptions);
        //     this.$scope.$on('$destroy', () => {
        //         this.elements.carousel.slick('unslick');
        //     });
        // }

        private initSlick(): void {

            let interval: number = 10,
                attempts: number = 5,
                stopTrying: ng.IPromise<string>;

            let tryInit = () => {
                const ready = this.elements.carousel[0].children && this.elements.carousel[0].children.length > 0;
                if (ready) {
                    // stop the loop
                    this.$interval.cancel(stopTrying);
                    // do the init
                    this.elements.carousel.slick(this.slickOptions);
                    this.show = true;
                    this.$scope.$on('$destroy', () => {
                        this.elements.carousel.slick('unslick');
                    });
                }
            };
            // start the loop
            stopTrying = this.$interval(tryInit, interval, attempts);
        }

    }

    angular
        .module('search')
        .directive('reviewSnippetBrowser', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: ReviewSnippetBrowser,
                controllerAs: 'rsb',
                transclude: true,
                bindToController: {
                    hotel: '='
                },
                templateUrl: 'partials/home/reviewsnippetbrowser',
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    controller : ReviewSnippetBrowser
                ) => {
                    const elements = {
                        carousel: el.find('.carousel')
                    };
                    controller.init(elements);
                }
            };
        });


}
